<div #mobilePremiumOffcanvas class="offcanvas offcanvas-bottom" tabindex="-1" [id]="content?.id"
    [attr.aria-labelledby]="(content?.id ||'offcanvas')+'Label'">
    <div class="offcanvas-header header-sec">
        <div class="heading">Your details & premiums</div>
        <button type="button" id="" name="" class="btn-close text-reset pt-2" (click)="closeOffcanvas()"></button>
    </div>
   <div class="offcanvas-body">
        <div class="block-sec">
            <div class="head text-start">Your current policy</div>
            <div class="divider_yellow"></div>
            <ul class="policy-list">
                <li>Provider: {{PolicyDetailResponse?.planName || ''}}
                </li>
                
                <li>Policy Type:  {{PolicyDetailResponse?.productType || ''}} 
                </li>
                
                <li>Policy Number: {{PolicyDetailResponse?.policyNumber || ''}}
                </li>
                
                <li>Policy Status: {{PolicyDetailResponse?.status || ''}}</li>
                
                <li>Start Date: {{PolicyDetailResponse?.effDate || ''}}
                </li>
            </ul>
        </div>
        <div class="block-sec" *ngIf="PolicyDetailResponse?.policyRelation?.length > 0">
            <div class="head text-start">Who is your primary beneficiary?</div>
            <div class="divider_yellow"></div>
            <ng-container *ngFor="let relation of PolicyDetailResponse?.policyRelation">
            <ul class="policy-list-last">
                <li>Name: {{relation?.relationName || ''}}
                </li>               
                <li>Date Joined: {{relation?.relationStartDate || ''}}
                </li>
                  
            </ul>
            </ng-container>
 <button id="btn_userJourney_changeBeneficiariesCallbackRequest_lifePolicyPage"
            name="btn_userJourney_changeBeneficiariesCallbackRequest_lifePolicyPage"
             class="buttonReq" (click)="CallBackRequestEmail(12)">Request changes</button>
        </div>
        <div class="block-sec">
            <div class="head text-start">Your monthly premium</div>
            <div class="divider_yellow"></div>
            <ul class="policy-list">
                <li>
                    <div class="d-flex justify-content-between align-items-center gap-2">
                        <span>As a DebtBusters client, your insurance premium forms part of your regular monthly payments.</span>
                        <img src="../../../../../assets/images/dblogojm.png" class="db_Logo" alt="DB_Logo" />
                    </div>
                </li>

                <li>Premium: <span class="font-weight-bold">R {{ PolicyDetailResponse?.paymentAmt?? 0 | number:'1.0-2'}}</span>
                </li>
            </ul>
        </div>
        <div class="block-sec">
            <div class="head text-start">Your broker</div>
            <div class="divider_yellow"></div>
            <ul class="policy-list-broker">
                <li>Name: Just Money Protect (Pty) Ltd
                </li>
                
                <li>FSP No.: 32984
                </li>
                
                <li>Tel: <a id="expertContactNumberLink" href="tel:0860994096" class="foofontstyle">086 099 4096</a>
                </li>
                
                <li>Email <a href="mailto:enquiries@justmoney.co.za"
                        class="foofontstyle">enquiries&#64;justmoneyprotect.co.za</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<ng-template #callbackSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free call-back incoming</h4>
    <button type="button" id="btn_auxiliaryButton_insuranceHub_callBackRequested_popUp_close" 
    class="close" data-dismiss="modal" name="btn_auxiliaryButton_insuranceHub_callBackRequested_popUp_close" isCloseButton="true"
    aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body"role="alert">
    <p>An agent will contact you shortly</p>    
  </div>
  <div class="modal-footer">
    <button id="btn_auxiliaryButton_insuranceHub_callBackRequested_popUp_close2" 
    name="btn_auxiliaryButton_insuranceHub_callBackRequested_popUp_close2"
      type="button" class="popup-border" (click)="modal.dismiss('Cross click')">OK, thanks!</button>
    
  </div>
</ng-template>